module.exports = __webpack_public_path__ + "img/bm9.87ab7a14.png";